import * as React from "react";

function SvgVero(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 40 36" {...{ ...props, ref }}>
      <path
        fill="#01B2D0"
        d="M35.253.002L35.103 0H4.68C2.076 0 0 2.085 0 4.701c0 .587.112 1.15.316 1.669.096.292.221.578.377.856L15.818 33.52c.217.376.477.711.77 1.002A4.69 4.69 0 0020.022 36a4.557 4.557 0 002.994-1.128c.457-.36.856-.814 1.166-1.353L39.307 7.226c.153-.272.277-.553.371-.84A4.566 4.566 0 0040 4.702C40 2.085 37.924 0 35.406 0c-.051 0-.102 0-.153.002zM21.495 24.725l11.961-20.85c.043-.06.071-.105.087-.131a2.072 2.072 0 011.863-1.132c1.083 0 1.994.916 1.994 2.09 0 .4-.132.794-.347 1.131a.118.118 0 00-.043.087L23.835 28.817l-2.34-4.092zM4.854 2.612h26.349l-2.34 4.092H4.852c-.04 0-.08-.002-.13 0-.03-.002-.069 0-.13 0-1.124 0-2.036-.916-2.036-2.003 0-1.173.912-2.09 2.037-2.09.06 0 .1.002.13 0l.046.001h.084zm7.781 6.704h14.73L20 22.118 12.635 9.316zm5.48 22.984c.003-.03-.012-.055-.044-.087L4.941 9.316h4.68l12.004 20.85a.59.59 0 00.087.175c.184.307.303.693.303 1.132 0 1.086-.91 2.002-1.993 2.002a2.116 2.116 0 01-1.907-1.175z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default React.forwardRef(SvgVero);
